<template>
    <div class="modal fade" id="modal-filter" tabindex="-1" role="dialog">
		<div class="modal-dialog" role="document">
			<div class="modal-content">

				<div class="modal-header">
                    <h4>Filtros</h4>
					<button type="button" class="close" @click="close_modal">&times;</button>
				</div>

				<div class="modal-body">
					<div v-for="(form, index) in filter_data" :key="index" class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label>{{ form.label }}</label>

                                <input  v-if="form.type == 'text'"   :id="'input-' + form.name" @change="set_filter(form)" class="form-control form-control-sm" type="text">
                                <input  v-if="form.type == 'phone'"  :id="'input-' + form.name" @change="set_filter(form)" class="form-control form-control-sm" type="text" v-mask="['(##) ####-####', '(##) #####-####']">
                                
                                <fieldset v-if="form.type == 'checkbox'">
                                    <label v-for="(opt,index) in form.data_get" :key="index">{{ opt }}&nbsp;-&nbsp;<input :id="'input-' + form.name + index" @change="set_filter(form,index)" :value="opt" type="checkbox">&nbsp;&nbsp;&nbsp;</label>
                                </fieldset>
                                
                               
                                <date-range-picker 
                                    class="date-range"
                                    v-if="form.type == 'date'"
                                    ref="picker"
                                    :locale-data="{ firstDay: 1, format: 'DD/MM/YYYY HH:mm' }"
                                    :timePicker="true"
                                    :timePicker24Hour="true"
                                    :autoApply="false"
                                    v-model="dateRange"
                                    @update="update_date"
                                />

                                <select v-if="form.type == 'select'" :id="'input-' + form.name" @change="set_filter(form)" class="form-control form-control-sm">
                                    <option v-for="(opt, index) in select_data" :key="index" :value="( opt.id ) ? opt.id : opt.ID">
                                        <span v-if="opt.nome">{{ opt.nome }}</span>
                                        <span v-else-if="opt.name">{{ opt.name }}</span>
                                        <span v-else>{{ opt.NAME }}</span>
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
				</div>

				<div class="modal-footer">
					<button class="btn btn-primary btn-sm" @click="send_filters">Filtrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import api     from "@/mixins/api.js"
    import replace from "@/mixins/replace.js"

    import DateRangePicker  from 'vue2-daterange-picker'
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

    export default {
        name: "Modal-Filter",
        props: [ 'filter_data' ],
        mixins: [ api, replace ],
        components: { DateRangePicker },

        data() { return {
            filter_values: [],
            aux_check: [],
            nome_check: null,
            select_data: null,
            data_aux: Date(),
            dateRange: { startDate: this.$moment(Date()).format("Y-MM-DD 00:00"), endDate: this.$moment(Date()).format("Y-MM-DD 23:59") }
        }},

        created() {
            this.filter_data.forEach( index => {
                if ( index.type == "select" ) this.get_data(index.data_get)
            })
        },

        methods: {
            set_filter(payload, index = null, value = null) {
                if (!value) {
                    if(payload.type == "phone"){
                        value = this.LimpaNum( $("#input-" + payload.name).val() );
                    }else{
                        if(payload.type == "checkbox"){
                            this.aux_check.push($("#input-" + payload.name + index).val());
                            this.nome_check = payload.name;
                        }else{
                            value = $("#input-" + payload.name).val();
                        }
                    }
                }
                if(value != undefined){
                    this.filter_values.push(`${payload.name}=${value}`);
                }
            },

            send_filters() {
                const query = this.mount_query_string()
                this.$emit('set_filter', query)

                this.close_modal()
            },

            close_modal() {
                this.filter_data.forEach( index => $("#input-" + index.name).val("") );
                this.dateRange = { startDate: Date(), endDate: Date() };
                this.filter_values = [];
                this.aux_cont = [];
                this.nome_check = "";
                $("#modal-filter").modal('hide')
            },

            mount_query_string() {
                let string = "";
                this.filter_values.forEach( index => string += `&${index}`);
                if(this.aux_check.length > 0){
                    string += '&'+this.nome_check+'=';
                    this.aux_check.forEach( index => string += `${index}-`);
                    string = string.slice(0,-1);
                    console.log(string);
                }
                return string;
            },

			async get_data(payload) {
				const response = await this.GET(payload)

				if ( response.status == "success" ) this.select_data = response.result
				else this.select_data = [{ id: 0, nome: "Falha ao buscar dados" }]
            },
            
            update_date() {
                const date_ini = this.$moment(this.dateRange.startDate).format("Y-MM-DD HH:mm")
                const date_fim = this.$moment(this.dateRange.endDate).format("Y-MM-DD HH:mm")

                this.set_filter( { name: 'date_ini' }, date_ini )
                this.set_filter( { name: 'date_fim' }, date_fim )
            },
        }

    }
</script>

<style>
    .date-range {
        width: 100%;
    }
</style>